<template>
  <v-dialog v-model="scenedialogStatus" max-width="800" transition="dialog-bottom-transition">
    <v-card class="mx-auto">
      <!-- <div style="padding: 20px; float: right">
        <v-btn class="dialogClose" icon color="gray" small @click="scenedialogStatus = false">
          <v-icon small>mdi-close</v-icon>
          <md-tooltip style="z-index: 999" md-direction="top">关闭</md-tooltip>
        </v-btn>
      </div> -->
      <div class="d-flex align-end my-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <!-- <v-icon color="white"> mdi-bookmark </v-icon> -->
          <span class="iconfont icon-changjing" style="color: #fff"></span>
        </v-card>
        <span class="h4 ml-1 mb-n1">任务场景信息</span>
      </div>
      <!-- <div class="py-5 d-flex justify-center align-center"> -->
      <div style="text-align: right; margin-right: 45px">
        <v-btn
          class="btnSceneAdd"
          icon
          color="green"
          @click.stop="$store.dispatch('editor/reverseShowSceneEdit', 'add')"
        >
        <span class="iconfont icon-tianjia" style="font-size: 20px;"></span>
          <md-tooltip style="z-index: 999" md-direction="top">新增任务场景</md-tooltip>
        </v-btn>
      </div>
      <!-- </div> -->
      <v-list class="px-10 py-5">
        <!-- <div class="px-3">
          <v-text-field
            color="green lighten-1"
            v-model="keywords"
            label="请输入搜索的任务场景名称"
          ></v-text-field>
        </div> -->
        <div v-if="filterSceneList.length === 0" class="grey--text pa-10 d-flex justify-center">
          暂无场景数据
        </div>
        <v-list-item-group
          v-model="form.taskEditor"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item v-for="(item, i) in filterSceneList" :key="i" :value="item._id">
            <v-list-item-content>
              <v-list-item-title class="text-body" :v-text="item.name">{{
                item.name
              }}</v-list-item-title>

              <v-list-item-subtitle :v-text="item.description"></v-list-item-subtitle>
            </v-list-item-content>
            <v-spacer></v-spacer>

            <v-btn class="btnSceneEdit" icon color="green" small @click.stop="toEditor(item)">
              <!-- <v-icon small>mdi-application-brackets</v-icon> -->
              <span class="material-icons" style="font-size:18px;">3d_rotation</span>
              <md-tooltip style="z-index: 999" md-direction="top">进入任务场景</md-tooltip>
            </v-btn>
            <v-btn icon color="success" class="copyScene" v-if="course.hasAuthModify" small @click.native="copyEditor(item)">
               <span class="material-icons" style="font-size:18px;">content_copy</span>
              <md-tooltip style="z-index: 999" md-direction="top">复制场景</md-tooltip>
            </v-btn>

            <v-btn class="SceneEdit" icon color="green" v-if="course.hasAuthModify" small @click.stop="toEdit(item)">
              <span class="material-icons" style="font-size:20px;">edit</span>
              <md-tooltip style="z-index: 999" md-direction="top">编辑场景</md-tooltip>
            </v-btn>

            <v-btn class="btnSceneDel" icon color="red" v-if="course.hasAuthModify" small @click.stop="delScene(item)">
              <span class="material-icons" style="font-size:20px;">delete_forever</span>
              <md-tooltip style="z-index: 999" md-direction="top">删除场景</md-tooltip>
            </v-btn>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" @click.stop="close">关闭</v-btn>
        <!-- <v-btn
          color="gray"
          @click.stop="
            $store.dispatch('courseAndProject/reverseShowSceneEdit', 'close')
          "
          >取消</v-btn
        > -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  computed: {
    ...mapGetters(['project', 'showScenetEdit', 'course', 'sceneList']),
    scenedialogStatus: {
      get() {
        const status = this.showScenetEdit;
        return status === 'edit' || status === 'add';
      },
      set(val) {
        if (!val) {
          this.$store.dispatch('courseAndProject/reverseShowSceneEdit', 'close');
        }
      },
    },
    courseList() {
      return this.$store.state.courseAndProject.courseList;
    },
    filterSceneList() {
      return this.sceneList.filter(item => new RegExp(this.keywords).test(item.name));
    },
  },
  watch: {
    scenedialogStatus(val) {
      // this.$store.dispatch('editor/refreshSceneList',this.course)
    },
    deep: true,
    showScenetEdit(val) {
      this.form = Object.assign({}, this.project);

      // if (val === "edit") {
      //   this.form = Object.assign({}, this.project);
      // } else {
      //   this.$refs.form?.resetValidation();
      //   this.form = {
      //     course: this.course._id,
      //   };
      // }
    },
    
  },
  data() {
    return {
      // tab: "",
      // items: ["基本信息", "任务场景"],
      form: {},
      keywords: '',
      valid: false,
    };
  },
  methods: {
    // isShown() {
    //   // 你可以在这里定义你的逻辑，例如：
    //   // 如果路由参数中包含id，并且id的值是你期望的值，则显示元素
    //   const tab = this.$route.query.tab
    //   if(tab=='0'){
    //      return false
    //   }
    //   return true
    // },
    close() {
      // this.scenedialogStatus = false
      this.$store.dispatch('courseAndProject/reverseShowSceneEdit', 'close');
    },
    checkNameRule(v) {
      if (v && v.length > 50) {
        return false;
      }
      return true;
    },
    async copyEditor(item) {
      this.$store.dispatch('editor/copyScene', item._id);
    },
    async delScene(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `场景 ${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('editor/removeScene', item);
      }
    },
    getUser(){
      let userId = ''
        if(window.localStorage.getItem('USER_INFO')){

          let data = JSON.parse(window.localStorage.getItem('USER_INFO'))
           if(data.user._id){
            userId = data.user._id
           }else{
            userId = ''
           }
        }

        return userId
    },
    toEdit(sceneInfo) {
      this.$store.dispatch('editor/setSceneInfo', Object.assign({}, sceneInfo));
      this.$store.dispatch('editor/reverseShowSceneEdit', 'edit');
    },
    toEditor(sceneInfo) {
      this.$store.dispatch('editor/setSceneInfo', sceneInfo);
      // this.$router.push({
      //   path: `/editor/${this.project._id}/${sceneInfo._id}`,
      // });
      // window.open(`/editor/${this.course._id}/${sceneInfo._id}`, "_blank");
   
      const openObj = window.open(`/editor/${this.course._id}/${sceneInfo._id}/${localStorage.getItem('token')}`, '_blank');

      const loop = setTimeout(() => {
        if (window.closed) {
          clearTimeout(loop);
        } else {
          openObj.document.title = '元学.3D场景编辑器';
          clearTimeout(loop);
        }
      }, 1000);

      this.$store.dispatch('courseAndProject/reverseShowProjectEdit', 'close');
    },
    showEdit() {
      const sceneInfo = this.taskSceneList.find(item => item._id === this.form.taskEditor);
      this.$store.dispatch('editor/setSceneInfo', sceneInfo);
      this.$store.dispatch('editor/reverseShowSceneEdit', 'edit');
    },
    async fileChange(e) {
      console.log('更改文件', e);
    },
    async submit() {
      // this.$store.dispatch("courseAndProject/saveProject", this.form);
      // this.$store.dispatch("courseAndProject/refreshCourseList");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.dialogClose >>> .v-btn__content i {
  font-size: 30px !important;
}
</style>
